// import { }
declare const site: server.dto.SiteData;

type ClientStatuses = keyof server.dto.ClientStatuses;
export const getStatuses = (key: ClientStatuses) => site.currentEnvironment.statuses[key];
